module.exports = __webpack_public_path__ + "img/reserve.a6368b5e.svg";